import "reflect-metadata";
import "@pixi/sound";
import { PeskyMoles } from "./by/gamefactory/peskymoles/PeskyMoles";
import "./utils/array.extensions";

function start(): void {
    const game = new PeskyMoles();
    const gameCanvas = game.view as HTMLCanvasElement;
    gameCanvas.id = "game-canvas";
    document.body.appendChild(gameCanvas);
    game.launch("assets/manifest.json");
}

function isPortrait(): boolean {
    return window.matchMedia("(orientation: portrait)").matches;
}

window.isPortrait = isPortrait;

start();
